import React from 'react'
import styled from 'styled-components'
import { Title } from '../../assets/styles/commonStyles'
import { useContext } from 'react'
import authContext from '../../context/auth-context'
import { useState } from 'react'
import { toast } from 'react-toastify';
import { useEffect } from 'react'
import { CartContext } from '../../context/CartContext'

const Container = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  padding:10px;
  div, form{
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
    width:100%;

    button{
      border:2px solid rgba(77,75,50,0.72);
      padding:10px;
      border-radius:10px;
      color:white;
      width:10%;
      margin-top:10px;
      font-size:16px;
      border:1px solid rgba(77,75,50,0.72);
      &:hover{
        cursor:pointer;
        color:black;
        background:#FCDA8B;
        box-shadow: 0px 0px 6px 5px rgba(77,75,50,0.72);
        border:1px solid #FCDA8B;
        transition:all 0.3s ease-in-out;
      }
      &:active{
        transform:scale(0.9);
      }
    }
  }
  h4{
      color:#FCDA8B;
      font-size:30px;
      margin-top:10px;
      letter-spacing:1.1px;
      font-weight:500;
      text-align:center;
      text-shadow: 0px 3px 28px gold;
    }
    @media screen and (max-width:1024px){
      form{
        button{
          width:50%;
        }
      }
    }
    @media screen and (max-width:768px){
      margin-top: 30px;
      form{
        button{
          width: 90%;
        }
      }
    }
    @media screen and (max-width:500px){
      form{
        button{
          width: 90%;
        }
      }
    }
`
const Input = styled.input`
  padding:10px;
  width:30%;
  margin:10px 0px;
  border-radius:6px;
  font-family:inherit;
  border:2px solid rgba(77,75,50,0.72);
  color:white;
  &:active, &:focus{
    outline:1px solid #FCDA8B;
  }
  @media screen and (max-width:1024px){
    width: 50%;
  }
  @media screen and (max-width:768px){
    width: 90%;
  }
  @media screen and (max-width:500px){
    width: 90%;
  }
`


const ContactMe = () => {
  const {submitContactMeForm, state} = useContext(authContext)
  const {setCart} = useContext(CartContext)
  const [data, setData] = useState({
    fullName:'',
    email:'',
    subject:'',
    number:'',
    message:'',
  })
  const submitFormHandler = (e) =>{
    e.preventDefault()
    submitContactMeForm(data)
  }
  useEffect(()=>{
    if(state.formSubmitted){
      toast(`form sent successfully`, {
        position: "bottom-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setData({
        fullName:'',
        email:'',
        subject:'',
        number:'',
        message:'',
      })
    }
    else if(state.formError){
        toast(`Oops ! something went wrong`, {
          position: "bottom-center",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
    }
  },[state.formSubmitted, state.formError])
  useEffect(()=>{
    // get the cart items from the localstorage
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    setCart(cartItems)
    // eslint-disable-next-line
  },[])
  return (
    <Container className={`animated slideInUp`}>
    <Title>CONTACT ME</Title>
    <form onSubmit={submitFormHandler}>
      <Input required value={data.fullName} onChange={(e)=>setData({...data, fullName:e.target.value})} placeholder='Full Name'/>
      <Input required value={data.email} onChange={(e)=>setData({...data, email:e.target.value})} type='email' placeholder='Email Address'/>
      <Input required value={data.subject} onChange={(e)=>setData({...data, subject:e.target.value})} placeholder='Subject'/>
      <Input required value={data.number} onChange={(e)=>setData({...data, number:e.target.value})} type='number' placeholder='Contact Number'/>
      <Input required value={data.message} onChange={(e)=>setData({...data, message:e.target.value})} placeholder='Your Message'/>
      <button type='submit'>Send</button>
    </form>
    </Container>
  )
}

export default ContactMe